<div class="flex-row">
  <app-disease-insight-toolbar
    [selectedCropField]="asBaseRegistration(selectedCropField())"
    [isParticipatingToBem]="isParticipatingToBem()"
    [plantDateConfig]="plantDateFieldConfig()"
    [emergenceDateConfig]="emergenceDateFieldConfig()"
    [harvestDateConfig]="harvestDateFieldConfig()"
    [plantDateMin]="plantDateLimits.min"
    [plantDateMax]="plantDateLimits.max"
    (plantDateChanged)="plantDateChanged.emit($event)"
    (emergenceDateChanged)="emergenceDateChanged.emit($event)"
    (harvestDateChanged)="harvestDateChanged.emit($event)"
    (plantDateChangedInFuture)="plantDateChangedInFuture.emit($event)"
  />

  <mat-form-field
    class="date-picker flex__child--auto selector"
    [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
    [matTooltipDisabled]="!isReadOnly()"
    (click)="!isReadOnly() && deadFoliageDatePicker.open()"
    (keydown.enter)="!isReadOnly() && deadFoliageDatePicker.open()"
    subscriptSizing="dynamic"
  >
    <mat-label class="date-picker-lable">{{ 'virusMonitor.virusDetails.deadFoliageDate' | translate }}</mat-label>
    <input
      class="date-picker-input"
      matInput
      [matDatepicker]="deadFoliageDatePicker"
      [formControl]="virusDeadFoliageDateFormControl"
      [min]="today"
    />
    <mat-datepicker-toggle matSuffix [for]="deadFoliageDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #deadFoliageDatePicker></mat-datepicker>
  </mat-form-field>

  <div class="virus-spray-threshold-container">
    <mat-form-field
      class="flex__child--auto selector"
      subscriptSizing="dynamic"
      [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
      [matTooltipDisabled]="!isReadOnly()"
    >
      <mat-label>{{ 'virusMonitor.virusDetails.sprayThreshold' | translate }}</mat-label>
      <input type="number" matInput [formControl]="virusSprayThresholdFormControl" min="0" max="99" />
      <span matTextSuffix>%</span>
    </mat-form-field>
  </div>
</div>
